/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { MainnetOtpVerifyResponse, MainnetOtpVerifyVars } from '../openapi-types.gen.js';

export type { MainnetOtpVerifyResponse, MainnetOtpVerifyVars } from '../openapi-types.gen.js';

export const useMainnetOtpVerify = createMutationHook<MainnetOtpVerifyVars, MainnetOtpVerifyResponse, unknown>({
  specName: 'useMainnetOtpVerify',
  path: '/v1/notifications/mainnet/otp/verify',
  method: 'POST',
  resolveUrl: (vars: MainnetOtpVerifyVars) => `/v1/notifications/mainnet/otp/verify`,
  buildBody: (vars: MainnetOtpVerifyVars) => ({ email: vars.email, code: vars.code }),
  parseResponse: (raw: unknown): MainnetOtpVerifyResponse => raw as MainnetOtpVerifyResponse,
  
  
  
});
